var render = function render(){var _vm=this,_c=_vm._self._c;return (this.model === 'Shared')?_c('div',[_c('shared-model',{attrs:{"row-data":_vm.billData,"title":_vm.title,"site-id":_vm.siteId,"tax":_vm.tax}})],1):_c('div',[_c('indivdual-model',{attrs:{"row-data":_vm.billData,"title":_vm.title,"site-id":_vm.siteId,"tax":_vm.tax}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }